import { render } from "./TheStall.vue?vue&type=template&id=5ef7a69a"
import script from "./TheStall.vue?vue&type=script&lang=js"
export * from "./TheStall.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__